// Styles
import "@mdi/font/css/materialdesignicons.css";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VNumberInput } from "vuetify/labs/VNumberInput";
import { VTimePicker } from "vuetify/labs/VTimePicker";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  components: {
    VDateInput,
    VTimePicker,
    VNumberInput,
  },
  theme: {
    defaultTheme: "light", // Start with light mode

    themes: {
      light: {
        colors: {
          // primary: "#DC143B",
          primary: "#294CFD",
          secondary: "#f6f8fa",

          greyVariant1: "#808080",
          greyVariant2: "#8c8f9d",
          greyVariant3: "#878a99",
          greyVariant4: "#495057",
          
          // textFieldBorderColor:"#B0B0B0",

          blueVariant1: "#def1fb",

          greenVariant1: "#d9f5f0",
          greenVariant2: "#00bd9d",

          primaryVariant1: "#DC143B",

          BlueColorVariant1: "#0a6d9c",
          BlueColorVariant2: "#0a6d91",
          BlueColorVariant3: "#2cb2f1",

          redVariant1: "#FECFD8",

          DarkBlue: "#050a30",
          NavyBlue: "#000c66",
          Blue2: "#0000ff",
          MidNightBlue: "#145da0",
          greenText: "#116530",
          unReadNotificationColor: "#B3E5FC",
          readNotificationColor: "#E1F5FE",
          textPrimary: "#000000",
          textSecondary: "#4A4A4A",
        },
      },
      dark: {
        colors: {
          primary: "#BB86FC",
          secondary: "#121212", // Darker background
          background: "#181818", // Set background dark
          surface: "#1E1E1E", // Surface color
          textPrimary: "#FFFFFF",
          textSecondary: "#B0B0B0",

          greyVariant1: "#4A4A4A",
          greyVariant2: "#525252",
          greyVariant3: "#5E5E5E",
          greyVariant4: "#6A6A6A",

          blueVariant1: "#1E3A5F",
          greenVariant1: "#1A4731",
          greenVariant2: "#2B7D66",

          primaryVariant1: "#BB86FC",

          BlueColorVariant1: "#0D47A1",
          BlueColorVariant2: "#1976D2",
          BlueColorVariant3: "#64B5F6",

          redVariant1: "#CF6679",

          DarkBlue: "#0A1929",
          NavyBlue: "#1A237E",
          Blue2: "#0D47A1",
          MidNightBlue: "#283593",
          greenText: "#00C853",
          unReadNotificationColor: "#37474F",
          readNotificationColor: "#455A64",

          textPrimary: "#FFFFFF",
          textSecondary: "#B0B0B0",
        },
      },
    },
  },
});